import './utils/Sentry';
import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import { UserContextProvider } from './context/UserContext';

import ErrorFallback from './components/ErrorComponent';
import { SnackbarProvider } from './context/SnackbarContext';
import { CampaignContextProvider } from './context/CampaignContext';

const root = document.createElement('div');
root.className = 'container';
root.style.padding = '0';

document.body.appendChild(root);
const rootDiv = ReactDOM.createRoot(root);
rootDiv.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={(errorData) => <ErrorFallback {...errorData} />}
    >
      <SnackbarProvider>
        <UserContextProvider>
          <CampaignContextProvider>
            <App />
          </CampaignContextProvider>
        </UserContextProvider>
      </SnackbarProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
